module.exports = __webpack_public_path__ + "static/media/radar.921d3eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/radar.svg
// module id = 354
// module chunks = 0